import { type ReactElement, type ReactNode } from "react"
import { ModalSize } from "./themes";

export interface ModalProps {
        isOpen: boolean;
        onClose: () => void;
        children: ReactNode
        modalSize?: string;
        height?: string;
}

export default function Modal(props: ModalProps): ReactElement {
        const modalSize = props.modalSize !== undefined ? props.modalSize as keyof typeof ModalSize : 'md';
        let classNames = "";
        if (modalSize === "custom") {
                classNames = ModalSize[modalSize] + " h-[" + props.height + "rem] bg-white rounded-lg shadow-lg p-6 w-full relative";
        }
        else {
                classNames = ModalSize[modalSize] + " bg-white rounded-lg shadow-lg p-6 w-full relative";
        }
        if (!props.isOpen) return <></>;
        return <>
                <div className="fixed inset-0 z-10 flex items-center backdrop-blur-sm justify-center h-full bg-black bg-opacity-50">
                        <div className={classNames}>
                                <button className="absolute top-2 right-2 text-gray-500 hover:text-gray-700" onClick={props.onClose}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                                </button>
                                {props.children}
                        </div>
                </div>
        </>
}
